import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { usersImporterActions } from '../actions/users-importer.actions';
import { selectDownloadingTemplate, selectImporting, selectSummary } from '../selectors/users-importer.selector';

@Injectable({
    providedIn: 'root',
})
export class UsersImporterFacade {
    private readonly store = inject(Store);

    readonly importing = this.store.selectSignal(selectImporting);
    readonly summary = this.store.selectSignal(selectSummary);
    readonly downloadingTemplate = this.store.selectSignal(selectDownloadingTemplate);

    readonly importing$ = this.store.select(selectImporting);
    readonly summary$ = this.store.select(selectSummary);
    readonly downloadingTemplate$ = this.store.select(selectDownloadingTemplate);

    importLearners(schoolId: string, file: File): void {
        this.store.dispatch(usersImporterActions.importLearners({ schoolId, file }));
    }

    clearSummary(): void {
        this.store.dispatch(usersImporterActions.clearSummary());
    }

    downloadTemplate(): void {
        this.store.dispatch(usersImporterActions.downloadTemplate());
    }

    clear(): void {
        this.store.dispatch(usersImporterActions.clear());
    }
}
